import React from "react";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import "./less/video-player.style.less";

const VideoPlayer = (props) => {
    const { videoURL } = props;

    return (
        <Video
            autoPlay
            muted
            controls={["PlayPause", "Seek", "Time", "Volume", "Fullscreen"]}
        >
            <source src={videoURL} />
        </Video>
    );
};

export default VideoPlayer;
